module.exports = __webpack_public_path__ + "img/u18.f08ac740.png";